import { Home, Settings, Sun } from '@tamagui/lucide-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { Image, XStack, YStack } from 'tamagui';

import { SidebarButton } from './SidebarButton';
import { homeServiceLogo } from '../../assets';
import { useAppSync } from '../../contexts/AppSyncContext';
import { ROUTE_PATHNAMES, ROUTE_PATHS } from '../../routes/routeConstants';

export const Sidebar = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { hub: currentHub } = useAppSync();

  const isSettings = pathname.includes(ROUTE_PATHS.settings, 1);
  const isWeather = pathname.includes(ROUTE_PATHS.weather, 1);
  const isHome = pathname.includes(ROUTE_PATHS.dashboard) && !isSettings && !isWeather;
  const logoSource = currentHub?.logoUrl ? { uri: currentHub.logoUrl } : { uri: homeServiceLogo };

  return (
    <YStack
      width={220}
      height="100%"
      backgroundColor="$gray2"
      padding="$5"
      alignItems="center"
      justifyContent="space-between">
      {/* Logo container */}
      <XStack
        alignItems="center"
        justifyContent="center"
        height={100}
        width="100%"
        pressStyle={{ opacity: 0.8 }}
        cursor="pointer"
        onPress={() => {
          navigate(ROUTE_PATHNAMES.contact);
        }}>
        <Image
          source={logoSource}
          alt={currentHub?.name || 'Delta Home Services'}
          width="100%"
          height="100%"
          resizeMode="contain"
        />
      </XStack>

      {/* Navigation buttons */}
      <SidebarButton to={ROUTE_PATHNAMES.dashboard} isActive={isHome} icon={Home} />

      <SidebarButton to={ROUTE_PATHNAMES.weather} isActive={isWeather} icon={Sun} />

      <SidebarButton to={ROUTE_PATHNAMES.settings} isActive={isSettings} icon={Settings} />
    </YStack>
  );
};
